import { render, staticRenderFns } from "./ElementYearlyPrices.vue?vue&type=template&id=00267c5c"
import script from "./ElementYearlyPrices.vue?vue&type=script&lang=js"
export * from "./ElementYearlyPrices.vue?vue&type=script&lang=js"
import style0 from "./ElementYearlyPrices.vue?vue&type=style&index=0&id=00267c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports